import React from 'react';
import { useParams } from 'react-router-dom';
import '../styles/pages/BlogPost.css';
import { posts } from '../mocks/MockPosts';

const BlogPost = () => {
  const { id } = useParams();

  // Find the post with the matching ID
  const post = posts.find((post) => post.id === id);

  if (!post) {
    return <div>Post not found.</div>;
  }

  return (
    <div className="blog-post">
      <h1>{post.title}</h1>
      <p>By {post.author}</p>
      <div dangerouslySetInnerHTML={{ __html: post.content }} />
    </div>
  );
};

export default BlogPost;